import {EInterceptionObserver} from "../EIntersectionObserver/EIntersectionObserver";
import {LOADER_HTML} from "../topbottom/utils";
import {customCotFormat, getColorFormat} from "../../streaming/utils";
import {renderIntradayHighChart, setGlobalHighStockOptions} from "../highchart/customConfig";
import {quotesTimeDate, unmaskpath, utmsToQueryString} from "../modulesUtils";
import './instrumentBox.scss';

let Highcharts = null;
let streamingProvider = null;


const renderInstrumentBox = (response, element, utms) => {
    const moduleData = response.data;
    const time = quotesTimeDate(moduleData.date);
    const baseUri = response.urlPrefix;
    const ticker = response.ticker;
    const uri = getBaseQuoteSlug(baseUri + "cotizaciones"
        , moduleData.dataType, moduleData.marketId, moduleData.status);

    const lastStr = customCotFormat('last', moduleData.last, 3);
    const varPercStr = customCotFormat('varPerc', moduleData.varPerc, 2);

    const chartId = 'instrumentBox' + (new Date()).getTime();
    element.innerHTML = `
<div class="headband">
    <h2 class="tx font600">
        <a class="lnk" href="${ uri + moduleData['slug'] + utmsToQueryString(utms)}">${moduleData['niceName']}</a>
    </h2>
    <time class="timestamp date-${ticker}" data-decimal="0" data-value="${moduleData.date}">
        ${time}
    </time>
</div>
<div class="mt">
    <div class="headline">
        <span class="last last-${ticker}" data-value="${moduleData.last}" data-decimal="3">${lastStr}</span>
        <span class="${getColorFormat(moduleData.varPerc)} varperc varPerc-${ticker}" 
            data-value="${moduleData.varPerc}" data-decimal="2">${varPercStr}</span>
    </div>
    <div class="inset-auto" id="${chartId}" style="height: 200px;"></div>
</div>
<div class="module-lnk-more">
    <a class="lnk lnk-more" href="${uri + moduleData['slug'] + utmsToQueryString(utms)}" title="Ir a ${moduleData['niceName']}">
        Ir a ${moduleData['niceName']}
    </a>
</div>`;

    response['chartId'] = chartId;
    renderIntradayHighChart(response, Highcharts);
}
/**
 *
 * @param {HTMLElement} element
 * @param {Object} utms
 * @constructor
 */
const InstrumentBox = async (element, utms) => {
    element.innerHTML = LOADER_HTML;
    Highcharts = await import("highcharts/highstock");
    setGlobalHighStockOptions(Highcharts);
    const ticker = element.dataset.ticker || 36833;
    const streamingAvailable = element.dataset.streaming || true;
    const urlPrefix = element.dataset.base || '/';
    const url = urlPrefix + unmaskpath('cotizaciones-instrumentbox##') + ticker;

    fetch(url, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => response.json())
        .then(response => {
            response['ticker'] = ticker;
            response['urlPrefix'] = urlPrefix;
            renderInstrumentBox(response, element, utms);

            if (streamingAvailable && streamingProvider) {
                streamingProvider.subscribeTickerIDS(ticker);
            } else {
                console.warn('No streaming given for Instrument Box');
            }

        })
        .catch(err => {
            console.error(err);
            console.error('Error when drawing Instrument box for id ' + ticker);
            element.parentNode.removeChild(element);
        });
}

export const GeneralInstrumentBox = (streamingModule, utms) => {
    streamingProvider = streamingModule;
    const elements = document.querySelectorAll('section.md-ibex-rates[data-ticker]');
    const cb = (target) => { InstrumentBox(target, utms) };
    EInterceptionObserver(elements, cb);
}

//Mantener la compatibilidad con los js ya existentes
export default GeneralInstrumentBox;
